<script setup lang="ts">
defineProps<{
  cityName?: string
}>()
</script>

<template>
  <div class="mx-auto w-fit">
    <div class="flex justify-between">
      <!-- Searchbar -->
      <div class="w-[600px]">
        <Skeleton v-if="!cityName" height="2rem"></Skeleton>
      </div>
    </div>
    <div class="my-6 flex h-[calc(100vh-(225px))] w-full justify-center gap-24">
      <!-- Map -->
      <div class="flex w-[600px] flex-col gap-4 overflow-hidden rounded-md">
        <div class="relative h-full flex-1">
          <Skeleton height="100%"></Skeleton>
          <img
            id="image"
            src="/images/icons/restaurantPin.svg"
            alt="restaurant pin"
            class="absolute left-1/3 top-1/3 opacity-50"
          />
          <img
            id="image"
            src="/images/icons/restaurantPin.svg"
            alt="restaurant pin"
            class="absolute left-2/3 top-1/2 opacity-50"
          />
          <img
            id="image"
            src="/images/icons/restaurantPin.svg"
            alt="restaurant pin"
            class="absolute left-1/3 top-2/3 opacity-50"
          />
        </div>
      </div>
    </div>
  </div>
</template>
